import React from "react";
import { BrowserRouter as Router, Link } from "react-router-dom";

class NavBar extends React.Component {
  hideNavItems = false;
  showNavHome = false;
  constructor(props) {
    super(props);
  }
  componentWillMount() {
    this.forceUpdate();
  }
  render() {
    if (window.location.pathname === "/privacy") {
      this.hideNavItems = true;
      this.showNavHome = true;
    } else if (window.location.pathname === "/") {
      this.hideNavItems = false;
      this.hideNavItems = false;
    } else if (window.location.pathname === "/about") {
      this.hideNavItems = true;
      this.showNavHome = true;
    }

    return (
      <div>
        <nav className="navbar navbar-expand-md bg-inverse fixed-top scrolling-navbar">
          <div className="container">
            <Link to="{/home}" className="navbar-brand">
              <img
                src="assets/img/logo.png"
                style={{ height: "60px", widows: "15px" }}
                alt="jira timesheets plugin for jira.com"
              />
            </Link>
            <button
              className="navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target="#navbarCollapse"
              aria-controls="navbarCollapse"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <i className="lni-menu"></i>
            </button>
            <div className="collapse navbar-collapse" id="navbarCollapse">
              <ul className="navbar-nav mr-auto w-100 justify-content-end clearfix">
                {this.showNavHome ? (
                  <li className="nav-item ">
                    <a className="nav-link" href="index.html">
                      Home
                    </a>
                  </li>
                ) : null}

                {!this.hideNavItems ? (
                  <li className="nav-item ">
                    <Link
                      className="nav-link"
                      to={{ pathname: "/", hash: "#hero-area" }}
                    >
                      Home
                    </Link>
                  </li>
                ) : null}
                {!this.hideNavItems ? (
                  <li className="nav-item ">
                    <Link className="nav-link" to="#services">
                      Timesheets for jira
                    </Link>
                  </li>
                ) : null}
                {!this.hideNavItems ? (
                  <li className="nav-item ">
                    <Link className="nav-link" to="#testimonial">
                      Features
                    </Link>
                  </li>
                ) : null}

                {/*   {!this.hideNavItems ? (
                  <li className="nav-item">
                    <Link className="nav-link" to="#contact">
                      Contact us
                    </Link>
                  </li>
                ) : null} */}
              </ul>
            </div>
          </div>
        </nav>
      </div>
    );
  }
}

export default NavBar;



// WEBPACK FOOTER //
// ./src/components/navbar.js